import {
  Button,
  Descriptions,
  Icons,
  Input,
  Space,
  Table,
  TableProps,
} from '@pankod/refine-antd'
import React, { useRef, useState } from 'react'
import Highlighter from 'react-highlight-words'

import TextFieldWithEmpty from '@resources/pendaftaran-diklat/block/TextFieldWithEmpty'
import { DiklatProgramLocal } from '@resources/pendaftaran-diklat/types'

import type { InputRef } from 'antd'

type TableSelectProgramLocal = {
  rowSelection: TableProps<DiklatProgramLocal>['rowSelection']
  onRow: TableProps<DiklatProgramLocal>['onRow']
  dataSource: TableProps<DiklatProgramLocal>['dataSource']
}

const TableSelectProgramLocal = ({
  rowSelection,
  onRow,
  dataSource,
}: TableSelectProgramLocal) => {
  const searchInput = useRef<InputRef>(null)
  const [searchText, setSearchText] = useState<React.Key>('')

  return (
    <Table
      rowKey={'id'}
      pagination={false}
      className="!w-full"
      tableLayout="fixed"
      scroll={{ y: 200 }}
      size="small"
      rowSelection={rowSelection}
      onRow={onRow}
      columns={[
        {
          title: 'Program Lokal',
          dataIndex: 'name',
          render: (text) => (
            <Highlighter
              searchWords={[searchText.toString()]}
              highlightClassName="text-orange-40"
              highlightStyle={{ padding: 0 }}
              autoEscape
              textToHighlight={text}
            />
          ),
          filterIcon: (filtered: boolean) => (
            <Icons.SearchOutlined
              style={{ color: filtered ? '#1890ff' : undefined }}
            />
          ),
          onFilter: (value, record) =>
            record['name']
              .toString()
              .toLowerCase()
              .includes((value as string).toLowerCase()),
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
              <Input
                ref={searchInput}
                placeholder={`Cari program lokal`}
                value={`${selectedKeys[0] || ''}`}
                onChange={(e) => {
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }}
                onPressEnter={() => {
                  confirm()
                  setSearchText(selectedKeys[0])
                }}
                style={{ marginBottom: 8, display: 'block' }}
              />
              <Space>
                <Button
                  type="primary"
                  onClick={() => confirm()}
                  icon={<Icons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                >
                  Cari
                </Button>
                <Button
                  onClick={() => {
                    clearFilters?.()
                    setSearchText('')
                    confirm()
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          ),
        },
        {
          title: 'Wilayah',
          width: 450,
          render: (_, record) => (
            <Descriptions
              size="small"
              column={1}
              labelStyle={{ width: '150px' }}
              bordered
            >
              <Descriptions.Item label="Provinsi">
                <TextFieldWithEmpty value={record.provinsi} />
              </Descriptions.Item>
              <Descriptions.Item label="Kota/Kabupaten">
                <TextFieldWithEmpty value={record.kotaKab} />
              </Descriptions.Item>
              <Descriptions.Item label="Kecamatan">
                <TextFieldWithEmpty value={record.kecamatan} />
              </Descriptions.Item>
            </Descriptions>
          ),
        },
        {
          title: 'Jumlah Partisipan',
          dataIndex: 'participantNumber',
          render: (value) => <TextFieldWithEmpty value={value} />,
          width: 100,
          className: 'align-top',
          align: 'center',
        },
      ]}
      dataSource={dataSource}
    />
  )
}

export default TableSelectProgramLocal
